/**
 * Created by roman.kupin on 10/3/2017.
 */

import AccountApiActions from "../../../../actions/accountApi";

export const PREFIX = "[BigPicture]";
export const INITIALIZED = `${PREFIX}.Initialized`;
export const DATE_RANGE_CHANGE = `${PREFIX}.DateRangeChange`;


export function initialized(value) {
    return dispatch => {
        dispatch({ type: INITIALIZED, payload: value });
    }
}

export function dateRangeChange(companyUuid, startDate, endDate) {
    return (dispatch, getState, { dateSerializer }) => {
        const state = getState();
        dispatch({ type: DATE_RANGE_CHANGE, payload: { startDate, endDate } });
        return dispatch(AccountApiActions.getPropertiesStatistics(companyUuid, dateSerializer(startDate), dateSerializer(endDate)))
            .then(() => {
                dispatch(initialized(true));
            });
    }
}

const All = { initialized, dateRangeChange };
export default All;